import { useMutation } from '@tanstack/react-query';
import analyticsUseCase from '../factories/analytics';

export const useEmitAnalyticsDataLayerEvent = () => {
  const mutation = useMutation(analyticsUseCase.emitDataLayerEvent);

  return mutation;
};
